import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { useChannelSight } from "../../hooks/channel-sight-manager";
import useStoreLocator from "../../hooks/use-store-locator";
import WhereToBuyIcon from "../../icons/dove-acquistare.svg";
import WhereToBuyModal from "../where-to-buy-modal";
import { Link } from "../link";

const ButtonWTB = ({
  reevooTrack,
  sku,
  assetId,
  label,
  className,
  priceData,
  location,
  storeLink,
}) => {
  const [campaign, setCampaign] = useState();
  const [source, setSource] = useState();
  const [medium, setMedium] = useState();
  const [content, setContent] = useState();
  const [term, setTerm] = useState();
  const [slPage, setSlPage] = useState();

  useEffect(() => {
    if (sessionStorage.getItem("utm_campaign")) {
      setCampaign(sessionStorage.getItem("utm_campaign"));
    }
    if (sessionStorage.getItem("utm_source")) {
      setSource(sessionStorage.getItem("utm_source"));
    }
    if (sessionStorage.getItem("utm_medium")) {
      setMedium(sessionStorage.getItem("utm_medium"));
    }
    if (sessionStorage.getItem("utm_content")) {
      setContent(sessionStorage.getItem("utm_content"));
    }
    if (sessionStorage.getItem("utm_term")) {
      setTerm(sessionStorage.getItem("utm_term"));
    }
    if (sessionStorage.getItem("cookiesClosed")) {
      setSlPage(sessionStorage.getItem("cookiesClosed"));
    }
  }, []);

  const [showAlert, setShowAlert, handleWTBClick] = useChannelSight(location);
  const closeAlert = () => {
    if (sessionStorage.getItem("cookiesClosed")) {
      setSlPage(sessionStorage.getItem("cookiesClosed"));
    }
    setShowAlert(false);
    window.location.reload();
  };

  const storeLocatorPage = useStoreLocator();

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        whereToBuy
      }
    }
  `);
  return slPage ? (
    <Link
      to={!!storeLink ? storeLink : storeLocatorPage}
      target={!!storeLink ? "_blank" : "_self"}
      className="btn-link btn-link--blue align-self-md-stretch"
      rel="noreferrer"
    >
      <WhereToBuyIcon className="icon-svg-detail" />
      {labelManagerLabels.whereToBuy}
    </Link>
  ) : !!storeLink && !slPage ? (
    <Link
      to={storeLink}
      target={!!storeLink ? "_blank" : "_self"}
      className="btn-link btn-link--blue align-self-md-stretch mt-3"
      rel="noreferrer"
    >
      <WhereToBuyIcon className="icon-svg-detail" />
      {labelManagerLabels.whereToBuy}
    </Link>
  ) : (
    <>
      <button
        className={className}
        onClick={() => {
          reevooTrack();
          handleWTBClick();
        }}
        data-product-sku={sku}
        data-asset-id={assetId}
        data-csi_utm_campaign={campaign}
        data-csi_utm_source={source}
        data-csi_utm_medium={medium}
        data-csi_utm_term={term}
        data-csi_utm_content={content}
      >
        {priceData ? (
          <WhereToBuyIcon className="icon-svg" />
        ) : (
          <WhereToBuyIcon className="icon-svg-detail" />
        )}
        {label}
      </button>
      {showAlert && <WhereToBuyModal show={showAlert} onHide={closeAlert} />}
    </>
  );
};

export default ButtonWTB;
